import React, { useState } from "react"
import {Box, styled} from "@mui/material"
import PropTypes from "prop-types"
import {getImageForPath} from "../../../../anwendungskonfigurator/misc/utils"
import {EditIcon} from "lucide-react"

const StyledBox = styled(Box)(({theme}) => theme.WELTBOARD.ItemVisual)

const ItemVisual = ({type, objekte, triggerAction}) => {
    const [isHovered, setIsHovered] = useState(false)
    const objekt = objekte?.find((entry) => entry.label === type)

    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "grab",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            {
                <img
                    width={objekt.iconWidth ?? 100}
                    src={getImageForPath(objekt.icon)}
                />
            }
            {isHovered && (
                <StyledBox
                    sx={{border: isHovered ? "2px solid" : "none"}}
                    onMouseDown={(e) => {
                        e.stopPropagation()
                    }}
                    onClick={() =>
                        triggerAction("WELTBOARD_DIALOG_OPEN", {objekt})
                    }>
                    <EditIcon sx={{fontSize: 16, color: "white"}} />
                </StyledBox>
            )}
        </Box>
    )
}

ItemVisual.propTypes = {type: PropTypes.string}

export default ItemVisual
